// project import
import Routes from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import { SocketProvider } from "./socket/SocketContext";

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => (
    <SocketProvider>
        <ThemeCustomization>
            <ScrollTop>
                <Routes />
            </ScrollTop>
        </ThemeCustomization>
    </SocketProvider>
);

export default App;
